import React from 'react';
import ShowMoreAndLessText from "../../../components/showMoreAndLessText";

const WorkProcedureCard = ({workProcedure}) => {

    return (
        <div className="card-container work-procedure-card">
            <div className="card-title-section">
                <span>Work procedure</span>
            </div>
            <div className="card-content-section">
                <ShowMoreAndLessText html={workProcedure} maxLength={200}/>
            </div>
        </div>
    );
};

export default WorkProcedureCard;
